import { forwardRef, InputHTMLAttributes } from 'react';
import { foundationSemantic } from '../../foundation';
import { cx } from './utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, className, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      className={cx(
        'w-full border text-sm',
        foundationSemantic.input.base,
        foundationSemantic.input.field,
        foundationSemantic.input.surface,
        foundationSemantic.input.border,
        foundationSemantic.input.text,
        foundationSemantic.input.placeholder,
        invalid && foundationSemantic.input.invalid,
        className
      )}
      aria-invalid={invalid || undefined}
      {...props}
    />
  );
});

export default Input;
export type { InputProps };
